import React from 'react'
import {find, last} from 'lodash'
import {Button} from 'react-bootstrap'

import * as questionService from '../../../services/question-service'
import * as answerService from '../../../services/answer-service'

import IconTooltip from '../../../components/IconTooltip'
import Question from '../../../components/Question'
import {buildAnswerMap} from '../../../utils'
import PrintExtendedHeader from '../../../components/PrintExtendedHeader'
import PrintScanScores from '../../../components/PrintScanScores'
import PrintQuestionAnswers from '../../../components/PrintQuestionAnswers'
import PrintChangedQuestions from '../../../components/PrintChangedQuestions'

import {ScanResultContext} from '../../../context/ScanResultContext'

export default class AnalysisQuestions extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.handleChange = this.handleChange.bind(this)
    this.collectQuestionsWithChangedAnswers = this.collectQuestionsWithChangedAnswers.bind(this)

    this.state = {
      questions: {coreQuestions: []},
      answers: [],
      originalAnswers: [],
      questionsWithChanges: []
    }
  }

  componentDidMount() {
    Promise.all([
      answerService.getAnswers(this.props.scan.id),
      answerService.getAnswers(this.props.originalScan.id),
      questionService.getQuestion(1, this.props.scan.id)
    ]).then(([answers, originalAnswers, questions]) => {
      this.setState({answers, originalAnswers, questions})
      window.sessionStorage.setItem('analysis', JSON.stringify(this.state))
    })
  }

  getPhaseQuestions(questions, answers, originalAnswers) {
    const {filter} = this.props

    let filteredQuestions = []

    questions.coreQuestions.map(category => {
      return category.questions.map(question => {
        let option = find(question.options, o => o.phaseId === filter.phaseId)
        return option ? filteredQuestions.push(question) : null
      })
    })

    return (
      <div className="scan-container">
        <div className="scan-section">
          {filteredQuestions.map((question, i) => (
            <Question
              key={i}
              question={question}
              onChange={this.handleChange}
              state={answers}
              originalState={originalAnswers}
              completed={false}
              answermap={buildAnswerMap(questions, answers)}
              analyse = {true}
              orginalScan = {this.props.originalScan}
            />
          ))}
        </div>
      </div>
    )
  }

  getWheelQuestions(questions, answers, originalAnswers) {
    const {filter} = this.props
    let filteredQuestions = []

    questions.coreQuestions.map(category => {
      return category.questions.map(question => {
        let option = find(question.options, o => o.wheelId === filter.steeringWheelId)
        return option ? filteredQuestions.push(question) : null
      })
    })

    return (
      <div className="scan-container">
        <div className="scan-section">
          {filteredQuestions.map((question, i) => (
            <Question
              key={i}
              question={question}
              onChange={this.handleChange}
              state={answers}
              originalState={originalAnswers}
              completed={false}
              answermap={buildAnswerMap(questions, answers)}
              analyse = {true}
              orginalScan = {this.props.originalScan}
            />
          ))}
        </div>
      </div>
    )
  }

  getAllQuestions(questions, answers, originalAnswers) {
    return (
      <div className="scan-container">
        <div className="scan-section" key={123}>
          <h2>
            Vragen vooraf <IconTooltip id={"vragen_vooraf_kop"} icon="far fa-info-circle"/>
          </h2>

         {questions.genericQuestions && questions.genericQuestions.map((question, i) => (   // slice() is used to get rid of the first introduction question because this should never change (patieten, bewoners of clienten)
            <Question
                  key={i}
                  question={question}
                  onChange={this.handleChange}
                  state={answers}
                  originalState={originalAnswers}
                  completed={false}
                  answermap={buildAnswerMap(questions, answers)}
                  analyse ={true}
                  orginalScan = {this.props.originalScan}
                />
            )).slice(1,3)}
        </div>


        {questions.coreQuestions.map((category, index) => (
          <div className="scan-section" key={index}>
            <h2>
              Fase {index + 1}: {category.headerText} <IconTooltip id={category.headerText} icon="far fa-info-circle"/>
            </h2>

            {category.questions.map((question, i) => (
              <Question
                key={i}
                question={question}
                onChange={this.handleChange}
                state={answers}
                originalState={originalAnswers}
                completed={false}
                answermap={buildAnswerMap(questions, answers)}
                analyse = {true}
                orginalScan = {this.props.originalScan}
              />
            ))}
          </div>
        ))}
      </div>
    )
  }

  getQuestionsWithChangedAnswers(questions, answers, originalAnswers, questionsWithChanges) {
    return (
      <div>
        {questionsWithChanges.length === 0 &&
          <p>U heeft nog geen antwoorden aangepast. Klik links op totaalscore, een stuurwielonderdeel of een ontwikkelfase om de bijbehorende vragen en antwoorden te bekijken.</p>
        }
        <div className="scan-container">
          {questionsWithChanges.map((question, index) => (
            <div className="changed-group" key={index}>
              <Question
                key={index}
                question={question}
                onChange={this.handleChange}
                state={answers}
                originalState={originalAnswers}
                completed={false}
                answermap={buildAnswerMap(questions, answers)}
                analyse = {true}
                orginalScan = {this.props.originalScan}
              />
            </div>
            )
          )}
        </div>
      </div>
    )
  }

  handleChange(e, values, save) {
    let answers = this.state.answers
    let scanId = this.props.scan.id
    let type = e.target.type

    let promises = []
    if (type === 'radio') {
      const optionId = parseInt(e.target.value, 10)

      // Update all others too
      for (let i = 0; i < values.length; i++) {
        const booleanValue = values[i] === optionId

        promises.push(answerService.upsertAnswer({scanId, optionId: values[i], booleanValue}))

        let answer = find(answers, a => a.optionId === values[i])
        if (!answer) {
          answer = {scanId, optionId: values[i]}
          answers.push(answer)
        }
        answer.booleanValue = booleanValue
      }
    } else if (type === 'checkbox') {
      const optionId = parseInt(e.target.value, 10)
      const booleanValue = e.target.checked

      promises.push(answerService.upsertAnswer({scanId, optionId, booleanValue}))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = {scanId, optionId}
        answers.push(answer)
      }

      const lastOptionId = last(values)
      if (lastOptionId === optionId) {
        const rest = values.slice(0, -1)

        for (let i = 0; i < rest.length; i++) {
          promises.push(answerService.upsertAnswer({scanId, optionId: rest[i], booleanValue: false}))

          let restAnswer = find(answers, a => a.optionId === rest[i])

          if (!restAnswer) {
            restAnswer = {scanId, optionId: rest[i]}
            answers.push(restAnswer)
          }
          restAnswer.booleanValue = false
        }
      } else {
        promises.push(answerService.upsertAnswer({scanId, optionId: lastOptionId, booleanValue: false}))

        let lastAnswer = find(answers, a => a.optionId === lastOptionId)
        if (!lastAnswer) {
          lastAnswer = {scanId, optionId, booleanValue: false}
          answers.push(lastAnswer)
        }
        lastAnswer.booleanValue = false
      }
      answer.booleanValue = booleanValue
    } else if (type === 'select-one') {
      const optionId = values
      promises.push(answerService.upsertAnswer({scanId, optionId, stringValue: e.target.value }))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = {scanId, optionId}
        answers.push(answer)
      }
      answer.stringValue = e.target.value
    } else {
      const optionId = values
      const stringValue = e.target.value
      promises.push(answerService.upsertAnswer({scanId, optionId, stringValue}))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = {scanId, optionId}
        answers.push(answer)
      }
      answer.stringValue = stringValue
    }

    Promise.all(promises).then(() => {
      this.setState({ answers }, () => { this.props.answerChanged()
        this.collectQuestionsWithChangedAnswers() })
      window.sessionStorage.setItem('analysis', JSON.stringify(this.state))
    })
  }

  collectQuestionsWithChangedAnswers() {
    let questionsWithChanges = []

    this.state.questions.coreQuestions.map((category, index) => {
      return category.questions.map((question) => {
        let same = true
        question.options.map((option) => {
          const originalAnswer = find(this.state.originalAnswers, s => s.optionId === option.id)
          const analysisAnswer = find(this.state.answers, s => s.optionId === option.id)
          return same &= (originalAnswer !== undefined &&
            analysisAnswer !== undefined &&
            originalAnswer.booleanValue === analysisAnswer.booleanValue &&
            originalAnswer.stringValue === analysisAnswer.stringValue) ||
            (originalAnswer === undefined && analysisAnswer === undefined)
        })
        return !same ? questionsWithChanges.push(question) : null
      })
    })

    this.setState({questionsWithChanges})
    window.sessionStorage.setItem('analysis', JSON.stringify(this.state))
  }

  render() {
    const {mode, filter, setMode, scan, originalScan, total, phaseTotals, wheelTotals, currentUnit} = this.props
    const {answers, originalAnswers, questions, questionsWithChanges} = this.state

    return (
      <div className="col col-options scans">
        {mode === 'start' && <div className="block">
          <h2 className="block-title">Aangepaste antwoorden en hun impact <IconTooltip text="<p>Hier ziet u de antwoorden op vragen die u heeft aangepast om te beoordelen welke risico's en maatregelen tot een andere score leiden. Klik links op totaal score, een stuurwielonderdeel of een ontwikkelfase om de bijbehorende vragen en antwoorden te bekijken.</p><p>Aangepaste antwoorden zijn alleen voor analyse, ze vervangen de gegeven antwoorden niet. Indien u de analyse wilt bewaren, klikt u op Download (PDF).</p>" icon='far fa-info-circle'/></h2>
          {this.getQuestionsWithChangedAnswers(questions, answers, originalAnswers, questionsWithChanges)}
        </div>}

        {mode === 'total' && <div className="block">
          <div className="col-floated">
            <div className="btn-container"><Button className="btn-close" onClick={() => setMode('start')}>Close</Button></div>
            {this.getAllQuestions(questions, answers, originalAnswers)}
          </div>
        </div>}

        {mode === 'wheel' && <div className="block">
          <div className="col-floated">
            <div className="btn-container"><Button className="btn-close" onClick={() => setMode('start')}>Close</Button></div>
            <h2 className="block-title">Vragen met impact op {filter.steeringWheel} <IconTooltip id={filter.steeringWheel} icon='far fa-info-circle'/></h2>
            {filter.score ? this.getWheelQuestions(questions, answers, originalAnswers) :
               <p className="scan-section"> Aan dit stuurwiel zijn op dit moment geen vragen gekoppeld </p> }
          </div>
        </div>}

        {mode === 'phase' && <div className="block">
          <div className="col-floated">
            <div className="btn-container"><Button className="btn-close" onClick={() => setMode('start')}>Close</Button></div>
            <h2 className="block-title">Vragen met impact op {filter.phase} <IconTooltip id={filter.phase} icon='far fa-info-circle'/></h2>
            {this.getPhaseQuestions(questions, answers, originalAnswers)}
          </div>
        </div>}

        <ScanResultContext.Consumer>
          {ctx => {
            if (ctx.state.printPdf === true) {
              window.sessionStorage.setItem('printPdf', true)

              return (
                <div className="print-pdf">
                  <PrintExtendedHeader scan={scan} originalScan={originalScan} currentUnit={currentUnit} type="analysis" />
                  <PrintScanScores scan={scan} originalScan={originalScan} total={total} wheelTotals={wheelTotals} phaseTotals={phaseTotals} type="analysis" />
                  <PrintQuestionAnswers scan={scan} originalScan={originalScan} answers={answers} originalAnswers={originalAnswers} questions={questions} type="analysis" />
                  <PrintChangedQuestions scan={scan} originalScan={originalScan} answers={answers} originalAnswers={originalAnswers} questions={questions} questionsWithChanges={questionsWithChanges} />
                </div>
              )}
            }
          }
        </ScanResultContext.Consumer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Analysis/components/AnalysisQuestions.js